import s from "./SavoirFaire.module.scss";

import img1 from "../../assets/images/savoir-faire-1.jpg";
import img2 from "../../assets/images/savoir-faire-2.jpg";
import img3 from "../../assets/images/savoir-faire-3.jpg";
import img4 from "../../assets/images/savoir-faire-4.jpg";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import ParagraphReveal from "../ParagraphReveal/ParagraphReveal";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { titleInEase } from "../../utils/Eases";
import { useTranslation } from "react-i18next";

const SavoirFaire = () => {
  const aluminiumRef = useRef();
  const titleRef = useRef();

  const { t } = useTranslation();

  useEffect(() => {
    // const titles = gsap.utils.toArray(titleRef.current.children);
    const chars = gsap.utils.toArray(aluminiumRef.current.children);
    const imagesWrapper = gsap.utils.toArray("[data-img]");

    const spansArray = document.querySelectorAll(
      "#savoir-faire [data-reveal] span:not([data-rotation])"
    );

    const spansToRotate = document.querySelectorAll(
      "#savoir-faire span[data-rotation]"
    );

    imagesWrapper.forEach((wrapper) => {
      gsap.fromTo(
        wrapper.children[0],
        {
          "will-change": "opacity, transform",
          opacity: 0,
          rotateX: () => gsap.utils.random(-120, 120),
          z: () => gsap.utils.random(-200, 200),
        },
        {
          ease: "power1",
          opacity: 1,
          stagger: 0.05,
          rotationX: 0,
          z: 0,
          scrollTrigger: {
            trigger: wrapper,
            start: "center bottom",
            end: "bottom top+=20%",
            scrub: true,
          },
        }
      );
    });

    chars.forEach((char) => {
      gsap.fromTo(
        char,
        {
          "will-change": "opacity, transform",
          opacity: 0,
          rotateX: () => gsap.utils.random(-100, 100),
          z: () => gsap.utils.random(-100, 100),
        },
        {
          ease: "none",
          opacity: 1,
          rotateX: 0,
          z: 0,
          stagger: 0.02,
          scrollTrigger: {
            trigger: char,
            start: "top 75%",
            end: "bottom 50%",
            scrub: true,
            // markers: {},
          },
        }
      );
    });

    gsap.fromTo(
      spansToRotate,
      {
        transformOrigin: "center center",
        rotateX: -270,
        opacity: 0,
        y: "15%",
      },
      {
        opacity: 1,

        stagger: 0.2,
        rotateX: 0,
        duration: 1.2,
        ease: titleInEase,
        scrollTrigger: {
          trigger: titleRef.current,
          start: "center bottom",
          end: "bottom 50%",
          // scrub: true,
        },
      }
    );

    gsap.fromTo(
      spansArray,
      {
        y: "150%",
        opacity: 0,
      },
      {
        y: "15%",
        opacity: 1,
        stagger: 0.05,
        duration: 1.2,
        ease: titleInEase,
        scrollTrigger: {
          trigger: titleRef.current,
          start: "center bottom",
          end: "bottom 50%",
          // scrub: true,
        },
      }
    );

    // ScrollTrigger.refresh();
  }, []);
  return (
    <div id="savoir-faire" className={s.savoirfaire}>
      <h1 ref={titleRef}>
        <div data-reveal className={s.anUnique}>
          <div>
            {t("savoir_faire.an", { returnObjects: true }).map(
              (item, index) => {
                return (
                  <span
                    key={item.letter + index}
                    className={item.className}
                    {...item.attributes}
                  >
                    {item.letter}
                  </span>
                );
              }
            )}
          </div>
          <div className={s.unique}>
            {t("savoir_faire.unique", { returnObjects: true }).map(
              (item, index) => {
                return (
                  <span
                    key={item.letter + index}
                    className={item.className}
                    {...item.attributes}
                  >
                    {item.letter}
                  </span>
                );
              }
            )}
          </div>
        </div>
        <div data-reveal className={s.savoir}>
          {/* <span>s</span>
          <span>a</span>
          <span>v</span>
          <span data-rotation className={`salmon`}>
            o
          </span>
          <span>i</span>
          <span>r</span> */}
          {t("savoir_faire.savoir", { returnObjects: true }).map(
            (item, index) => {
              return (
                <span
                  key={item.letter + index}
                  className={item.className}
                  {...item.attributes}
                >
                  {item.letter}
                </span>
              );
            }
          )}
        </div>
        <div data-reveal className={s.faire}>
          {t("savoir_faire.faire", { returnObjects: true }).map(
            (item, index) => {
              return (
                <span
                  key={item.letter + index}
                  className={item.className}
                  {...item.attributes}
                >
                  {item.letter}
                </span>
              );
            }
          )}
        </div>
      </h1>

      <div ref={aluminiumRef} className={s.aluminium}>
        <span className={s.a}>A</span>
        <span className={`${s.l} yellow`}>L</span>
        <span className={s.firstU}>U</span>
        <span className={`${s.middleM} salmon`}>M</span>
        <span className={s.firstI}>I</span>
        <span className={`${s.n} yellow`}>N</span>
        <span className={`${s.secondI}`}>I</span>
        <span className={`${s.secondU}`}>U</span>
        <span className={`${s.secondM} salmon`}>M</span>
      </div>

      <div className={s.content}>
        <ParagraphReveal className={s.intro}>
          {t("savoir_faire.intro")}
        </ParagraphReveal>

        <div className={s.img1} data-img>
          <img src={img1} alt="" />
        </div>

        <ParagraphReveal className={s.bring}>
          {t("savoir_faire.bring")}
        </ParagraphReveal>

        <ParagraphReveal className={s.specialist}>
          {t("savoir_faire.specialist")}
        </ParagraphReveal>

        <div className={s.img2} data-img>
          <img src={img2} alt="" />
        </div>

        <ParagraphReveal className={s.molten}>
          {t("savoir_faire.molten")}
        </ParagraphReveal>

        <div className={s.img3} data-img>
          <img src={img3} alt="" />
        </div>

        <div className={s.img4} data-img>
          <img src={img1} alt="" />
        </div>

        <ParagraphReveal className={s.cleansed}>
          {t("savoir_faire.cleansed")}
        </ParagraphReveal>

        <div className={s.img5} data-img>
          <img src={img4} alt="" />
        </div>

        <ParagraphReveal className={s.longevity}>
          {t("savoir_faire.longevity")}
        </ParagraphReveal>
      </div>
    </div>
  );
};

export default SavoirFaire;
